import React from "react";
import MobileMenuHeader from "./MobileMenuHeader";
import MobileMenuNavigation from "./MobileMenuNavigation";
import type { MobileMenuItem } from "../types/mobileNavigation";

interface MobileMenuDrawerProps {
  isMenuOpen: boolean;
  activeSubmenu: string | null;
  menuItems: MobileMenuItem[];
  logoProps?: { src?: string; alt?: string };
  onClose: () => void;
  onSubmenuToggle: (menuKey: string, hasSubmenu: boolean) => void;
  contactAction?: () => void;
  contactText?: string;
}

const MobileMenuDrawer: React.FC<MobileMenuDrawerProps> = ({
  isMenuOpen,
  activeSubmenu,
  menuItems,
  logoProps,
  onClose,
  onSubmenuToggle,
  contactAction,
  contactText,
}) => (
  <>
    {isMenuOpen && (
      <div
        className="fixed inset-0 z-40 bg-black bg-opacity-5"
        onClick={onClose}
        aria-hidden
      />
    )}

    <div
      className={`fixed right-0 top-0 z-50 h-full w-full transform border-l-[3px] border-r-[3px] border-t-[3px] border-muted bg-white shadow-xl transition-transform duration-300 ease-in-out ${
        isMenuOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <MobileMenuHeader logoProps={logoProps} isMenuOpen={isMenuOpen} onClose={onClose} />

      <MobileMenuNavigation
        menuItems={menuItems}
        activeSubmenu={activeSubmenu}
        onSubmenuToggle={onSubmenuToggle}
        contactAction={contactAction}
        contactText={contactText}
      />
    </div>
  </>
);

export default MobileMenuDrawer;
